import { useMemo } from 'react';
import { useAppContext } from 'src/contexts/AppContext';
import { Content } from 'src/contexts/ContentContext';
import { ErrorIconMessage } from 'src/core/POS/ErrorIconMessage';
import { ContentId } from 'src/utils/constants/contentId';
import { SellerAccountState } from 'src/WebApiController';

import { notificationContainer } from './AccountInactiveNotification.css';

export const AccountInactiveNotification = () => {
  const { loginContext } = useAppContext();
  const accountEnabled = useMemo(
    () =>
      loginContext?.user?.activeAccount?.sellerAccountState ===
      SellerAccountState.Active,
    [loginContext?.user?.activeAccount?.sellerAccountState]
  );

  if (accountEnabled) {
    return null;
  }
  return (
    <div className={notificationContainer}>
      <ErrorIconMessage alignment="center">
        <Content id={ContentId.AccountInactive} />
      </ErrorIconMessage>
    </div>
  );
};
